
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customcreartuvj1_676339f09ccea34376cf813a } from '../../api/formulariocontactanos3lmag.api'

import './nuestrosserviciosiggm2.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pnuestrosserviciosiggm2 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);


  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6754a27e1de4874021c17939" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <span>Inicio</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <span>Sobre Nosotros</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/servicios"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <span>Servicios</span>
    </div>
    
      </a>
      
      </div>
      
      <div
        id="im2y2e"
        className=""
        data-aos="zoom-out-down"
        data-aos-duration="1500"
      >
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4afizry.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iacot" className="">
      
      <a
        target=""
        className=""
        id="i2hsg"
        href="/contrata"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <span>Contrata</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="im06bc"
        href="/contacto"
        type="button"
      >
        
    <div id="ifflju" className="">
    <span>Contacto</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ixxmu"
        href="/proveedores"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <span>Proveedores</span>
    </div>
    
      </a>
      
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <span>Inicio</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <span>Sobre Nosotros</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/servicios"
        type=""
      >
        <span>Servicios</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contrata"
        type=""
      >
        <span>Contrata</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <span>Contacto</span>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/proveedores"
        type=""
      >
        <span>Proveedores</span>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i17hyw" className="">
      
      </div>
      
      <div
        id="i2u156"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="iz8mng" className="">
      
      <div id="io8y2k" className="">
      
      <div id="iuhg3b" className="">
      
    <div id="i4z4a8" className="">
    
    </div>
    
      <p className="" id="i4kgfg">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i510kh">
        <span>Eventos que van más allá de lo ordinario</span>
      </span>
      
      </p>
      
      </div>
      
      <p className="" id="ixk7il">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="i5k697">
        <span>NUESTROS SERVICIOS</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ima16j" className="">
      
      </div>
      
      <div id="ipenyj" className="">
      
      <div id="iaj45f" className="">
      
      <div id="i9kg5y" className="">
      
      <div
        id="i83so8"
        className=""
        data-aos="flip-right"
        data-aos-duration="2000"
      >
      
      <div id="izicsk" className="">
      
      <img
        className=""
        id="il35kk"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4el38gb.png"
        alt="undefined"
      />
      
      <p className="" id="iniooi">
        <span>BODAS</span>
      </p>
      
      </div>
      
      </div>
      
      <div
        id="iu90qh"
        className=""
        data-aos="flip-right"
        data-aos-duration="2000"
      >
      
      <div id="ir89kx" className="">
      
      <img
        className=""
        id="ixtpj1"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4el3hf5.png"
        alt="undefined"
      />
      
      <p className="" id="ivvewj">
        <span>GRADUACIÓN</span>
      </p>
      
      </div>
      
      </div>
      
      <div
        id="i3yxad"
        className=""
        data-aos="flip-right"
        data-aos-duration="2000"
      >
      
      <div id="ijdxa2" className="">
      
      <img
        className=""
        id="ig9lzc"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4el3ifb.png"
        alt="undefined"
      />
      
      <p className="" id="i1crzh">
        <span>REUNIONES</span>
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="igi947" className="">
      
      <div
        id="ive7gj"
        className=""
        data-aos="flip-left"
        data-aos-duration="2500"
      >
      
      <div id="ij7vah" className="">
      
      <img
        className=""
        id="ify9wr"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4el3lkh.png"
        alt="undefined"
      />
      
      <p className="" id="i82c1c">
        <span>FIESTAS</span>
      </p>
      
      </div>
      
      </div>
      
      <div
        id="ia9q0v"
        className=""
        data-aos="flip-left"
        data-aos-duration="2500"
      >
      
      <div id="is86hd" className="">
      
      <img
        className=""
        id="ipjgpi"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4el3mte.png"
        alt="undefined"
      />
      
      <p className="" id="ig2833">
        <span>CUMPLEAÑOS</span>
      </p>
      
      </div>
      
      </div>
      
      <div
        id="i7tsdn"
        className=""
        data-aos="flip-left"
        data-aos-duration="2500"
      >
      
      <div id="ifp65i" className="">
      
      <img
        className=""
        id="ikjfn6"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4el3nx5.png"
        alt="undefined"
      />
      
      <p className="" id="ikkym6">
        <span>CORPORATIVOS</span>
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="io4l7f" className="">
      
      </div>
      
      <div id="ijyhqk" className="">
      
      <p className="" id="izd8cf">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="iwq0hk">
        <span>SOMOS MÁS QUE PLANIFICADORES DE EVENTOS</span>
      </span>
      
      </p>
      
      <div id="iy89uj" className="">
      
      <div id="ipt0xi" className="">
      
      <div id="iv7lvx" className="">
      
      <div id="i1ghoq" className="">
      
      <div id="icxw56" className="">
      
      </div>
      
      <p className="" id="iyhmwh">
        <span>Creando Unión Inolvidable</span>
      </p>
      
      </div>
      
      <p className="" id="iqt7vh">
        <span>BODAS DE ENSUEÑO</span>
      </p>
      
      </div>
      
      <div id="impd5n" className="">
      
      <p className="" id="iqobfe">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ije25h">
        <span>Imagina tu boda ideal y déjanos encargarnos del resto. Desde la selección del lugar perfecto hasta la coordinación del día del evento, diseñamos cada detalle para que tu día especial sea una representación auténtica de tu amor y compromiso.</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iy4cuf" className="">
      
      </div>
      
      <div id="iwytdm" className="">
      
      <p className="" id="i5znhb">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itvkie">
        
      <span className="" id="">
        
      </span>
      <span>TU EVENTO ES NUESTRO COMPROMISO</span>
      </span>
      
      </p>
      
      <div id="ifhe55" className="">
      
    <div id="i486ur" className="">
    
    </div>
    
      <p className="" id="ix6aid">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i16wwz">
        <span>En cada uno de estos eventos, nuestra misión es superar tus expectativas y crear momentos que perduren en la memoria.</span>
      </span>
      
      </p>
      
    <div id="i2ydig" className="">
    
    </div>
    
      </div>
      
      <div id="idywn9" className="">
      
        <a
          target=""
          className=""
          id="i6fc8i"
          href="#"
        >
          
    <div id="ii9t0l" className="">
    <span>Comencemos Juntos</span>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="ir6wyt" className="">
      
      </div>
      
      <div id="i9goi1" className="">
      
      <div id="ip0qxf" className="">
      
      <div id="i68cuj" className="">
      
      <p className="" id="iszk86">
        
      <span className="" id="iw7wzt">
        <span>Comienza tu Historia con Ineven</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="i0s6tp" className="">
      
      <div id="iimphx" className="">
      
      <p className="" id="ids9we">
        
      <span className="" id="iofwwf">
        <span>¡Estamos emocionados por unirnos a ti en esta historia creativa!.</span>
      </span>
      
      </p>
      
      <p className="" id="i6p7lb">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ia7jlg">
        <span>Estamos emocionados por unirnos a ti en este viaje creativo.</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="icl0bc" className="">
      
      <p className="" id="irk6nw">
        
      <span className="" id="iiplmf">
        <span>Cuéntanos tus ideas</span>
      </span>
      
      </p>
      
      <p className="" id="iu4rfo">
        <span>Cuéntanos tus ideas</span>
      </p>
      
      <p className="" id="ik4qvs">
        <span>Ingresa tus datos</span>
      </p>
      
        <div className="" id="il9n2g">
          
      <form
        id="ikoru5"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await customcreartuvj1_676339f09ccea34376cf813a({
						nombreo31bw: e.target.nombreo31bw.value,
						telefono71bhf: e.target.telefono71bhf.value,
						correov6gp1l: e.target.correov6gp1l.value,
						cuentanostuideakfptok: e.target.cuentanostuideakfptok.value,
					});
					alert("Se agregó exitosamente");
		} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="i9a1tx" className="">
      
      <br className="" id="" />
      
      <input
        name="nombreo31bw"
        type="text"
        placeholder="Nombre"
        className="camposFormulario "
        id="i6e1bi"
      />
      
      </div>
      
      <div id="it2dcl" className="">
      
      <br className="" id="" />
      
      <input
        name="telefono71bhf"
        type="text"
        placeholder="Telefono"
        className="camposFormulario "
        id="i9bxpm"
      />
      
      </div>
      
      <div id="i0u3hh" className="">
      
      <br className="" id="" />
      
      <input
        name="correov6gp1l"
        type="text"
        placeholder="Correo"
        className="camposFormulario "
        id="ipau8u"
      />
      
      </div>
      
      <div id="i49c93" className="">
      
      <br className="" id="" />
      
      <input
        name="cuentanostuideakfptok"
        type="text"
        placeholder="Cuentanos tu Idea"
        className="camposFormulario "
        id="imtjpl"
      />
      
      </div>
      
      <button
        type="submit"
        name=""
        id="ijcz7x"
        className=""
        
      >
      
      <div id="inhef2" className="">
      <span>Enviar</span>
      </div>
      
      </button>
      
      </form>
      
        </div>
        
      <div id="iym77j" className="">
      
      <p className="" id="iynyxj">
        
      <span className="" id="ikcb1k">
        <span>¿Eres proveedor?</span>
      </span>
      
      </p>
      
        <a
          target=""
          className=""
          id="iowpze"
          href="#"
        >
          
    <div id="ioqyiy" className="">
    
      <span className="" id="ig5j4r">
        <span>Encuentra</span>
      </span>
      
    </div>
    
        </a>
        
      <p className="" id="iebja3">
        
      <span className="" id="ii5d7c">
        <span>nuevos clientes</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ir2czw" className="">
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4afizry.png"
        alt="undefined"
      />
      
      <p className="" id="iyo7r6">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="il8o0q">
        <span>Ingenieria de eventos.</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div id="ipwalf" className="">
      
      <img
        className=""
        id="icnrzk"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4vijr82.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="ick4rr"
          href="https://www.tiktok.com/@ineven.vip?_t=8sKdB0x1PBG&_r=1"
        >
          
    <div id="i9wn7w" className="">
    <span>ineven.vip</span>
    </div>
    
        </a>
        
      </div>
      
      <div id="iuupez" className="">
      
      <img
        className=""
        id="ivqr3i"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bmczdi.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="ixpcko"
          href="https://www.facebook.com/ineven.vip"
        >
          
    <div id="ip0qlz" className="">
    <span>ineven.vip</span>
    </div>
    
        </a>
        
      </div>
      
      <div id="igk236" className="">
      
      <img
        className=""
        id="i9z0pd"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bmd43v.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="ii7046"
          href="https://www.instagram.com/ineven.vip?igsh=b25xZHA5MDVqaDVp"
        >
          
    <div id="iorix4" className="">
    <span>@ineven.vip</span>
    </div>
    
        </a>
        
      </div>
      
      <div id="io5w49" className="">
      
      <img
        className=""
        id="i6uigw"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4viijg2.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="ilhwsl"
          href="https://www.linkedin.com/company/ineven/"
        >
          
    <div id="i0av9o" className="">
    <span>ineven.vip</span>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="i1rlot" className="">
      
      <p className="" id="iw7za7">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ic71jf">
        
      <a
        target=""
        className=""
        id="inwenq"
        href="/sobrenosotros"
        type=""
      >
        <span>Sobre nosotros</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="i3340b">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ih08ak">
        
      <a
        target=""
        className=""
        id="i1lpz6"
        href="/servicios"
        type=""
      >
        <span>Nuestros servicios</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="ijqtal">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itkfgw">
        
      <a
        target=""
        className=""
        id="i1lby1"
        href="/contrata"
        type=""
      >
        <span>Hazlo tú mismo</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="ik2e3t">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="it8v73">
        
      <a
        target=""
        className=""
        id="iqy2bl"
        href="/proveedores"
        type=""
      >
        <span>Testimonio</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="i38bqt">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ib7tnq">
        
      <a
        target=""
        className=""
        id="i0yqeu"
        href="/contacto"
        type=""
      >
        <span>Contáctanos</span>
      </a>
      
      </span>
      
      </p>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <p className="" id="ifh7p5">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ita68z">
        <span>+504 9574-8270</span>
      </span>
      
      </p>
      
      <p className="" id="i78qcc">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="imjhna">
        <span>Col. Colonia, 7 calle, 8 avenida S.O</span>
      </span>
      
      </p>
      
      <p className="" id="il1rnw">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6f3bu">
        <span>ingenierodeevento@gmail.com</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <p className="" id="izq2dp">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ieap6m">
        <span>Todos los derechos reservados - Ineven - 2022 </span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pnuestrosserviciosiggm2);
  